export default "__VITE_ASSET__DkIVE0bt__"